<template>
  <div>
    <b-button
      variant="primary"
      class="mb-1"
      @click="newAdminHandler"
    >
      Add New Admin
    </b-button>
    <admin-edit-modal
      :edit-admin-data.sync="editAdminData"
      @refetch-data="refetchData"
    />
    <admin-create-modal
      @refetch-data="refetchData"
    />

    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loadingAdmins"
    >
      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >
        <b-table
          ref="refAdminsListTable"
          class="position-relative"
          :items="fetchAdmins"
          :fields="tableColumns"
          responsive
          show-empty
          primary-key="email"
        >
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-b-modal.admin-edit-modal
                @click="editAdminData = data.item"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>
            </b-dropdown></template>
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BTable, BOverlay, BDropdownItem, BDropdown, VBModal, BButton,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import useAdminsList from '@/views/users/admins/useAdminsList'
import store from '@/store'
import adminStoreModule from '@/views/users/admins/adminStoreModule'
import AdminEditModal from '@/views/users/admins/AdminEditModal.vue'
import AdminCreateModal from './AdminCreateModal.vue'

export default {
  components: {
    BCard,
    BTable,
    BOverlay,
    BDropdownItem,
    BDropdown,
    AdminCreateModal,
    AdminEditModal,
    BButton,
  },
  directives: {
    'b-modal': VBModal,
  },
  setup(_, ctx) {
    // Register Admin Module
    const ADMIN_APP_STORE_MODULE_NAME = 'admins'

    // Register module
    if (!store.hasModule(ADMIN_APP_STORE_MODULE_NAME)) {
      store.registerModule(ADMIN_APP_STORE_MODULE_NAME, adminStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ADMIN_APP_STORE_MODULE_NAME)) store.unregisterModule(ADMIN_APP_STORE_MODULE_NAME)
    })

    const {
      refAdminsListTable,
      loadingAdmins,
      editAdminData,
      tableColumns,

      fetchAdmins,
      refetchData,
    } = useAdminsList()

    const newAdminHandler = () => {
      ctx.root.$bvModal.show('admin-create-modal')
    }

    return {
      refAdminsListTable,
      loadingAdmins,
      editAdminData,
      tableColumns,

      fetchAdmins,
      refetchData,

      newAdminHandler,
    }
  },
}
</script>

<style scoped>

</style>
